import { render, staticRenderFns } from "./SupplierDialogue.vue?vue&type=template&id=154902b5&"
import script from "./SupplierDialogue.vue?vue&type=script&lang=ts&"
export * from "./SupplierDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports